var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-top wrap"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideBtn),expression:"!hideBtn"}],staticClass:"back-btn",on:{"click":_vm.back}},[_vm._v("返回")])])}
var staticRenderFns = []

export { render, staticRenderFns }